<template>
  <div id="recruit-page">
    <div id="cover" v-if="isDetail" @click.self="toDetail"></div>
    <div class="banner-back">
      <router-link to="/"><img src="../assets/xf/logo3.png"/></router-link>
    </div>
    <div><img src="../assets/xf/joinus.jpg" style="width: 100%" /></div>
    <div class="recruit-box">
      <div class="recruit-detail">
        <div
          class="detail-box"
          v-for="(item, index) in recruitObj"
          :key="item.id"
          @click="selectJob($event, index)"
        >
          <img src="../assets/xf/logo.png" style="width: 50%;margin: 10% 15%" />
          <div class="detail-word">
            <h1>{{ item.name }}</h1>
            <h2>{{ item.time }}</h2>
            <h2 style="padding-bottom: 10px">{{ item.study }}</h2>
          </div>
          <div class="detail-btn" @click="toDetail">查看详情</div>
        </div>
      </div>
    </div>

    <div class="job-detail" v-if="isDetail">
      <div style="width: 110%;height: 100%;overflow-y: scroll">
        <h3 v-html="recruitObj[a].job"></h3>
        <a href="javascript:" class="job-btn" @click.stop="toDetail">确定</a>
      </div>
    </div>
    <div class="bottom-word">
      粤ICP备20039889号,Copyright2019广州颖上信息科技有限公司&copy版权所有
    </div>
  </div>
</template>

<script>
export default {
  name: "recruit",
  data() {
    return {
      isDetail: false,
      a: "",
      interceptRouter: true,

      recruitObj: [
        {
          id: 1,
          name: "前端工程师",
          time: "广州/经验1-3年",
          study: "本科及以上/全职",
          job:
            "【职位诱惑】 <br> 新平台,潜力大,资源支撑,福利多 <br>  <br> 【职位描述】  <br> " +
            "1、能够独立完成 Web系统的架构设计、模块设计和开发工作； <br>" +
            "2、注重用户体验，能准确理解并提炼用户需求； <br> " +
            "3、负责项目开发中的推进与协调工作。 <br>  <br> " +
            "【岗位要求】 <br> " +
            "1、本科以上学历，4年以上Web前端开发经验 ； <br> " +
            "2、 对html5, css3, es6等前端语言具有深入理解和丰富经验； <br> " +
            "3、对单页应用，模块化，响应式开发等有深入的理解 ； <br> " +
            "4、对前端开发的工程化、规范化、前后端协作等领域有较深的研究 ； <br> " +
            "5、对node.js/java等后端开发比较了解，熟悉http/https与restful等协议与规范； <br>  <br> " +
            "【工作地址】 <br> " +
            "广州 - 天河区 - 天河北 - 天河北路30号时代广场西座1006 <br> " +
            "【投递方式】  <br> " +
            "发送邮件到ligl@ibaybay.cn  <br> "
        },
        {
          id: 2,
          name: "内容运营(新媒体运营)",
          time: "广州/经验1-3年",
          study: "本科及以上/全职",
          job:
            "【职位诱惑】 <br> " +
            "大平台,机制好,机会多 <br>  <br> " +
            "【职位描述】 <br> " +
            "1、公司项目的营销体系日常运营，提高用户关注度和体验感 <br> " +
            "2、负责公司线上官方平台的日常内容撰写及运营； <br> " +
            "3、结合新媒体特性，对官方平台对外宣传内容的及时调整和更新； <br> " +
            "4、策划活动方案以及执行推广，并做相应的活动评估和总结； <br> " +
            "5、能独立撰写各类稿件 <br> " +
            "6、执行并监督所负责内容的输出和用户反馈； <br> " +
            "7、协助跨部门的内容合作，保障内容运营工作的顺利推进； <br>  <br>  " +
            "【任职要求】 <br> " +
            "1、一年以上相关工作经验，如互联网项目运营、文案岗位、微信公众号、APP运营经验； <br> " +
            "2、具有优秀的文案写作能力，能独立书写文案或软文； <br> " +
            "3、熟悉互联网运作和推广方式（H5、论坛、新媒体、自媒体推广、社区运营平台等具体操作）有较强的整合营销和活动策划落地能力； <br> " +
            "4、有激情，心智成熟，思维灵活且有逻辑性，有强烈的责任心和抗压能力，乐于挑战； <br> " +
            "5、有互联网网络营销、网络推广和新媒体策划经验优先。 <br>  <br> " +
            "【公司福利】 <br> " +
            "假期安排：享有国家劳动法规定的各种节假日。 <br> " +
            "工作时间： 朝九晚六的工作时间，双休给您足够的休息时间； <br> " +
            "晋升平台：为优秀人才提供展现才能的大平台和晋升机会； <br> " +
            "薪酬福利：根据各岗位各人才的技能要求，提供富有竞争力的薪酬待遇； <br> " +
            "社会福利：缴纳五险：养老、医疗、工伤、失业、生育以及住房公积金； <br> " +
            "员工福利：不定期举办员工文娱活动，员工生日、餐聚、聚会等各种腐败活动，带薪年休假，年度体检 <br>  <br> " +
            "【工作地址】 <br> " +
            "广州 - 天河区 - 天河北 - 天河北路30号时代广场西座1006  <br> " +
            "【投递方式】  <br> " +
            "发送邮件到ligl@ibaybay.cn  <br> "
        },
        {
          id: 3,
          name: "产品运营专员",
          time: "广州/经验1-3年",
          study: "本科及以上/全职",
          job:
            "【职位诱惑】 <br> " +
            "新平台,潜力大,资源支撑,福利多 <br>  <br> " +
            "【职位描述】 <br> " +
            "1、负责公司产品及业务流程梳理，平台及系统体系的产品运营策划工作； <br> " +
            "2、负责与UI、开发进行工作内容沟通，优化产品可用性，提升用户体验；  <br> " +
            "3、根据产品特点把握产品发展方向，及时根据各种统计数据和用户反馈，调动所有资源不断完善产品；  <br> " +
            "4、有电商产品经验者及产品运营经验者优先。 <br>  <br> " +
            "【任职资格】  <br> " +
            "1、本科以上学历，一年及以上互联网产品策划运营经验；  <br> " +
            "2、了解电商、金融等行业发展现状，有出色的逻辑分析能力、数据敏感度及项目推动能力；  <br> " +
            "3、具有团队意识，能推动技术执行、配合设计出图、具有运营策划逻辑者优先；  <br> " +
            "4、具备很好的抗压能力，高效执行、良好的跨部门沟通协作能力、个人陈述能力； <br>  <br> " +
            "【公司福利】  <br> " +
            "假期安排：享有国家劳动法规定的各种节假日。  <br> " +
            "工作时间： 朝九晚六的工作时间，双休给您足够的休息时间；  <br> " +
            "晋升平台：为优秀人才提供展现才能的大平台和晋升机会；  <br> " +
            "薪酬福利：根据各岗位各人才的技能要求，提供富有竞争力的薪酬待遇；  <br> " +
            "社会福利：缴纳五险：养老、医疗、工伤、失业、生育以及住房公积金；  <br> " +
            "员工福利：不定期举办员工文娱活动，员工生日、餐聚、聚会等各种腐败活动，带薪年休假，年度体检 <br>  <br> " +
            "【工作地址】 <br> " +
            "广州 - 天河区 - 天河北 - 天河北路30号时代广场西座1006  <br> " +
            "【投递方式】  <br> " +
            "发送邮件到ligl@ibaybay.cn  <br> "
        },
        {
          id: 4,
          name: "web开发工程师",
          time: "广州/经验1-3年",
          study: "本科及以上/全职",
          job:
            "【职位诱惑】 <br> " +
            "新平台,潜力大,资源支撑,福利多 <br> " +
            " <br> " +
            "【职位描述】 <br> " +
            "Python开发工程师 <br> " +
            " <br> " +
            "【职位要求】 <br> " +
            "1、熟悉Python语言，具有面向对象编程思维； <br> " +
            "2、熟悉Requests库的使用； <br> " +
            "3、熟悉MVT设计模式； <br> " +
            "4、具备良好的团队合作精神、沟通协调能力和学习能力； <br> " +
            "加分项：具有django开发经验的优先； <br>  <br> " +
            "【任职资格】 <br> " +
            "1、本科以上学历，有出色的逻辑分析能力、数据敏感度及项目推动能力； <br> " +
            "2、具有团队意识，具有运营策划逻辑者优先； <br> " +
            "3、具备很好的抗压能力，高效执行、良好的跨部门沟通协作能力、个人陈述能力； <br>  <br> " +
            "【工作地址】 <br> " +
            "广州 - 天河区 - 天河北 - 天河北路30号时代广场西座1006  <br> " +
            "【投递方式】  <br> " +
            "发送邮件到ligl@ibaybay.cn  <br> "
        },
        {
          id: 5,
          name: "产品专员",
          time: "广州/经验1-3年",
          study: "本科及以上/全职",
          job:
            "【职位诱惑】 <br> " +
            "新平台,金融行业,商业模式好,福利多 <br>  <br> " +
            "【职位描述】 <br> " +
            "【岗位职责】   <br> " +
            "1、负责公司业务流程梳理，平台及系统体系的产品策划工作；  <br> " +
            "2、负责与UI、开发进行工作内容沟通，优化产品可用性，提升用户体验；  <br> " +
            "3、根据产品特点把握产品发展方向，及时根据各种统计数据和用户反馈，调动所有资源不断完善产品；   <br> " +
            "4、有电商产品经验者优先。  <br>  <br> " +
            "【任职资格】 <br>  1、本科以上学历，一年以上互联网产品策划经验；   <br> " +
            "2、了解电商、O2O等行业发展现状，有出色的逻辑分析能力、数据敏感度及项目推动能力；   <br> " +
            "3、具有团队意识，能推动技术执行、配合设计出图、具有运营策划逻辑者优先；   <br> " +
            "4、具备很好的抗压能力，高效执行、良好的跨部门沟通协作能力、个人陈述能力； <br>  <br> " +
            "【公司福利】 <br> " +
            "假期安排：享有国家劳动法规定的各种节假日。   <br> " +
            "工作时间： 朝九晚六的工作时间，双休给您足够的休息时间；   <br> " +
            "晋升平台：为优秀人才提供展现才能的大平台和晋升机会；   <br> " +
            "薪酬福利：根据各岗位各人才的技能要求，提供富有竞争力的薪酬待遇；   <br> " +
            "社会福利：缴纳五险：养老、医疗、工伤、失业、生育以及住房公积金；   <br> " +
            "员工福利：不定期举办员工文娱活动，员工生日、餐聚、聚会等各种腐败活动，带薪年休假，年度体检 <br>  <br> " +
            "【工作地址】 <br> " +
            "广州 - 天河区 - 天河北 - 天河北路30号时代广场西座1006 <br> " +
            "【投递方式】  <br> " +
            "发送邮件到ligl@ibaybay.cn  <br> "
        }
      ]
    };
  },
  methods: {
    toDetail: function() {
      console.log("测试");
      this.isDetail = !this.isDetail;
    },
    selectJob: function(e, index) {
      this.a = index;
    }
  }
};
</script>

<style scoped>
#cover {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  background: rgb(102, 102, 102);
  opacity: 0.8;
  z-index: 9999;
}

/* ::-webkit-scrollbar 滚动条整体部分
   ::-webkit-scrollbar-thumb  滚动条里面的小方块，能向上向下移动（或往左往右移动，取决于是垂直滚动条还是水平滚动条）
   ::-webkit-scrollbar-track  滚动条的轨道（里面装有Thumb）
   ::-webkit-scrollbar-button 滚动条的轨道的两端按钮，允许通过点击微调小方块的位置。
   ::-webkit-scrollbar-track-piece 内层轨道，滚动条中间部分（除去）
   ::-webkit-scrollbar-corner 边角，即两个滚动条的交汇处
   ::-webkit-resizer 两个滚动条的交汇处上用于通过拖动调整元素大小的小控件*/
::-webkit-scrollbar {
  display: none;
}

h1 {
  font-family: SourceHanSansCN-Regular;
  font-size: 20px;
  color: #333;
  text-align: left;
  padding: 15px;
  margin: 0;
  margin-bottom: 20px;
}

h2 {
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  color: #818181;
  text-align: left;
  padding-left: 15px;
  letter-spacing: 2px;
  line-height: 20px;
}

h3 {
  font-family: SourceHanSansCN-Regular;
  font-size: 12px;
  color: #333333;
  text-align: left;
  line-height: 24px;
}

.banner-back {
  height: 70px;
  width: 100%;
  background: #0a396f;
}

.banner-back img {
  display: inline-block;
  padding-left: 20%;
  padding-top: 10px;
}

.bottom-word {
  width: 100%;
  height: 100px;
  background: #383838;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  color: #fafafb;
  text-align: center;
  line-height: 100px;
}

.recruit-box {
  width: 100%;
  background: url("../assets/xf/jrbg.jpg");
}

.recruit-detail {
  width: 82%;
  margin-left: 10%;
  padding-top: 44px;
}

.detail-box {
  width: 30%;
  margin: 16px;
  background: #fff;
  border: 1px #dcdcdc dashed;
  flex-direction: column;
  vertical-align: top;
  display: inline-block;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.detail-box:hover {
  -webkit-transform: translate3d(-3px, -3px, 8px);
  -moz-transform: translate3d(-3px, -3px, 8px);
  -ms-transform: translate3d(-3px, -3px, 8px);
  -o-transform: translate3d(-3px, -3px, 8px);
  transform: translate3d(-3px, -3px, 8px);
  box-shadow: 5px 5px 10px #888888;
  cursor: pointer;
}

.detail-word {
  background: #f5f5f5;
  width: 90%;
  height: 70%;
  margin: auto;
}

.detail-btn {
  width: 60%;
  margin: 10% 20%;
  border: 1px #dcdcdc solid;
  border-radius: 10px;
  font-family: SourceHanSansCN-Regular;
  font-size: 20px;
  color: #999;
  text-align: center;
  line-height: 50px;
  cursor: pointer;
}

.job-detail {
  width: 40%;
  height: 80%;
  position: fixed;
  margin-left: 25%;
  top: 50px;
  background: #fff;
  z-index: 99999;
  padding: 2% 5%;
  border-radius: 20px;
}

.job-btn {
  display: block;
  width: 20%;
  background: #213b89;
  font-family: SourceHanSansCN-Regular;
  font-size: 20px;
  color: #fff;
  line-height: 50px;
  text-align: center;
  -webkit-border-radius: 25px;
  -moz-border-radius: 25px;
  border-radius: 25px;
  margin: 0 auto 30px;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/views/recruit.vue